module.exports = __webpack_public_path__ + "img/userChose.dbd057ce.svg";